import React from 'react';

import { HeatMapGrid } from 'react-grid-heatmap';

export const YELLOW_COLOR = 'rgb(247, 173, 0)';

// These default value will be displayed when no param is provided
const X_LABELS_DEFAULT = new Array(12).fill(0).map((_, i) => `${i}`);
const Y_LABELS_DEFAULT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
const DATA_DEFAULT = new Array(Y_LABELS_DEFAULT.length)
  .fill(0)
  .map(() =>
    new Array(X_LABELS_DEFAULT.length).fill(0).map(() => Math.floor(Math.random() * 50 + 50))
  );

function GridHeatmap({
  xLabels = X_LABELS_DEFAULT,
  yLabels = Y_LABELS_DEFAULT,
  data = DATA_DEFAULT
}) {
  return <HeatMapGrid
    data={data}
    xLabels={xLabels}
    yLabels={yLabels}
    cellHeight='2rem'
    square
    xLabelsStyle={() => ({
      fontSize: '.6rem',
    })}
    cellStyle={(_x, _y, ratio) => {
      let backgroundColor;
      const calculatedRatio = Number.isNaN(ratio) ? data[_x][_y] / 100 : ratio;
      if (calculatedRatio === 1) {
        backgroundColor = 'green';
      } else if (calculatedRatio === 0) {
        backgroundColor = 'red';
      } else {
        backgroundColor = `${YELLOW_COLOR}`;
      }
      return {
        background: `${backgroundColor}`,
      }
    }}
  />
}

export default GridHeatmap;
